<template>
  <div class="flex flex-col h-full">
    <!-- Top section with fixed height based on content -->
    <div class="flex-shrink-0 relative p-4 sm:py-6 sm:px-10 bg-white rounded-t-lg sm:rounded-t-none">
      <div
        class="sm:absolute sm:inset-0 sm:bg-gradient-to-r sm:from-green-200/50 sm:via-blue-100/30 sm:to-blue-200/30"
      ></div>
      <div class="sm:absolute sm:inset-0 sm:bg-gradient-to-b sm:from-transparent sm:via-white/0 sm:to-white"></div>
      <!-- Content -->
      <div class="relative z-10 flex flex-col items-center w-full">
        <div class="text-center">
          <div class="text-2xl sm:text-3xl font-bold text-gray-800">{{ windowData.user.name }}</div>
          <p class="text-gray-600 text-lg sm:text-xl">{{ windowData.proposal.client.name }}</p>
        </div>
        <div
          class="w-full mt-4 flex justify-center"
          v-if="windowData.proposal.intro_video"
        >
          <div class="relative w-[420px] h-[200px] sm:w-[576px] sm:h-[288px] bg-white shadow-sm">
            <iframe
              :src="windowData.proposal.intro_video"
              class="absolute top-0 left-0 w-full h-full border-0"
              style="background: transparent"
              frameborder="0"
              webkitallowfullscreen
              mozallowfullscreen
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
    <!-- Bottom section that grows to fill available space -->
    <div class="flex-1 bg-white sm:px-10 px-5 py-3 flex flex-col items-center w-full text-sm">
      <div
        class="w-full max-w-xl intro-message-v-html-container prose"
        v-html="windowData.proposal.intro_text"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PortalBillingProposalIntro",
  data() {
    return {
      windowData: window.FinancialCents,
    }
  },
}
</script>
